import { gql } from '@apollo/client';
import { FIELD_FIELDS } from 'pe-core-frontend';
export const SAVE_FIELD = gql `
  ${FIELD_FIELDS}
  mutation SAVE_FIELD($input: FieldInput!) {
    saveField(input: $input) {
      __typename
      ... on Field {
        ...FieldFields
      }
      ... on MessageResponse {
        success
        messages {
          type
          value
          params
          sender
        }
      }
    }
  }
`;
